import { Component, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Grupo } from '../../../_models/grupo';
import { GrupoService } from '../../../_services/grupo.service';
import { TerceroService } from '../../../_services/tercero.service';
import { Tercero } from '../../../_models/tercero';

@Component( {
  selector: 'app-asignar-grupos-editar',
  templateUrl: 'asignar-grupos-editar.component.html'
} )

export class AsignarGruposEditarComponent implements OnInit {
  carInformacionInicial = true;
  acordion: number;
  busqueda: string;
  columnas: any[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  tabSeleccionado = 'GRUPOS';
  grupo: Grupo;
  todosGrupos: Grupo [] = [];
  gerentesOficina: Tercero [] = [];
  lisGerentesOficina: SelectItem [] = [];
  idEstructuraFisica: string;
  codExiste = false;


  constructor( private location: Location,
               private confirmationService: ConfirmationService,
               private navService: NavService,
               private conServicio: ConfirmationService,
               private grupoService: GrupoService,
               private terceroService: TerceroService,
               private fb: FormBuilder,
               private route: ActivatedRoute ) {

  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      /** verificamos que exista el idEstructuraFisica en la ruta*/
      if ( params[ 'idEstructura' ] !== '' && params[ 'idEstructura' ] !== null && params[ 'idEstructura' ] !== undefined ) {
        this.idEstructuraFisica = params[ 'idEstructura' ];
        /** obtenemos el grupo por ruta ( si este viene )*/
        if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
          this.grupoService.obtenerPorId( params[ 'id' ] ).subscribe( grupo => {
            this.grupo = grupo;
            this.cargarFormulario();
            this.cargarServicios();
          } );
        } else {
          this.cargarFormulario();
          this.cargarServicios();
        }
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    /**validación campos formulario*/
    if ( !this.codExiste && this.formulario.valid ) {
      /**confirmación para guardar el registro*/
      this.conServicio.confirm( {
        message: this.navService.buscarMensaje( 'MSG_GUARDAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'asignar-grupos',
        accept: () => {
          // Guardar - actualizar grupo
          const datosGrupo = this.formulario.value;
          this.guardando = true;
          this.guardarGrupo( datosGrupo );
        },
        reject: () => {
        }
      } );
    }
  }

  guardarGrupo( grupo: Grupo ) {
    /**Se actualiza el registro*/
    if ( grupo.idGrupo !== '' && grupo.idGrupo !== null && grupo.idGrupo !== undefined ) {
      /** Validación de que el código no se encuentre en uso*/
      if ( (this.todosGrupos.find( x => x.codigo === grupo.codigo &&
        x.idGrupo !== this.grupo.idGrupo )) !== undefined ) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'GRUPO.MSG_CODIGOENUSO' )
        } );
        this.guardando = false;
      } else {
        this.grupoService.actualizar( grupo ).subscribe( rta => {
          this.grupo = rta;
          this.cargarFormulario();
          this.cargarServicios();
          this.guardando = false;
          this.navService.setMesage( 2 );
        }, error => {
          this.navService.setMesage( 3 );
          this.guardando = false;
        } );
      }
    } else {
      /** Se crea un nuevo registro */
      /** Validación de que el código no se encuentre en uso*/
      if ( (this.todosGrupos.find( x => x.codigo === grupo.codigo )) !== undefined ) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'GRUPO.MSG_CODIGOENUSO' )
        } );
        this.guardando = false;
      } else {
        this.grupoService.crear( grupo ).subscribe( rta => {
          this.grupo = rta;
          this.cargarFormulario();
          this.cargarServicios();
          this.navService.setMesage( 1 );
          this.guardando = false;
        }, error => {
          this.navService.setMesage( 3 );
          this.guardando = false;
        } );
      }
    }
  }

  regresar( dirty: boolean ) {
    /*
    if (dirty) {
      this.conServicio.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
     */
    this.location.back();
  }

  cargarServicios() {
    forkJoin( this.grupoService.listado(),
      this.terceroService.listadoPorEstructuraFisicaConNivelTres( this.idEstructuraFisica, 3 ) ).subscribe(
      ( [ grupos, terceros ] ) => {
        this.todosGrupos = grupos;
        this.gerentesOficina = terceros;
        this.carInformacionInicial = false;
        this.lisGerentesOficina = [];
        this.gerentesOficina.map( ( s: Tercero ) => {
          this.lisGerentesOficina.push( { label: s.nombreCompleto, value: s.idUsuario } );
        } );
      }
    );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idGrupo: this.grupo ? this.grupo.idGrupo : null,
      idEstructuraFisica: [ this.idEstructuraFisica, [ Validators.required ] ],
      codigo: [ this.grupo ? this.grupo.codigo : null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      nombre: [ this.grupo ? this.grupo.nombre : null, [ Validators.required, Validators.maxLength( 50 ) ] ],
      descripcion: [ this.grupo ? this.grupo.descripcion : null, [ Validators.required, Validators.maxLength( 500 ) ] ],
      idUsuario: [ this.grupo ? this.grupo.idUsuario : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.grupo ? this.grupo.indicadorHabilitado : true ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'GRUPOS';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'ZONAS';
        break;
      }
      default: {
        break;
      }
    }
  }

  validarCodigo() {
    this.codExiste = this.todosGrupos.find( x => x.codigo == this.f.codigo.value && (!this.grupo || this.grupo.idGrupo !== x.idGrupo) ) ? true : false;
  }
}
